import React from "react";
import { Routes, Route } from "react-router-dom";
import ReporteImpuestosPage from "../pages/ReporteImpuestosPage";

const ReporteImpuestosRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<ReporteImpuestosPage />} />
    </Routes>
  );
};

export default ReporteImpuestosRoutes;
